import * as React from "react";
const SvgVector = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 14, viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 13L7 7L1 1", stroke: "white", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgVector;
